import { Box } from '@mui/material';

export const Textbox = ({ gridArea, background, marginBottom, children }) => {
	return (
		<Box style={{
			gridArea: gridArea,
			backgroundColor: background,
			marginBottom: marginBottom,
			padding: '1rem',
		}}>{children}</Box>
	);
};